<div
  class="flex flex-col overflow-hidden items-stretch justify-start w-full h-full p-2 scrollbar-dark"
>
  @if (currentPlans()?.length === 0) {
    <div class="flex flex-col items-center justify-center w-full h-full gap-2">
      <p class="text-neutral-400 text-sm font-bold">No plans generated yet</p>
      <p class="text-neutral-400 text-xs italic">
        Chat with the AI to generate a plan for your process.
      </p>
    </div>
  } @else {
    <div
      class="flex flex-col w-full scrollbar-dark gap-2 items-center rounded-lg text-xs overflow-y-auto"
    >
      @for (plan of currentPlans(); track plan) {
        <div
          class="flex flex-col w-full gap-2 items-center rounded-lg px-3 py-4 text-xs shadow-md select-none bg-neutral-900"
        >
          <div class="flex flex-row w-full gap-2 items-center justify-between">
            <div class="flex flex-row gap-2 items-center">
              <i
                [ngClass]="'ph-' + plan.plan_icon"
                class="ph bg-yellow-500 rounded-lg p-1 text-neutral-800 text-[20px] mr-2"
              ></i>
              <p class="text-white font-bold text-[18px] text-sm">{{ plan.plan_name }}</p>
            </div>
          </div>

          <div class="flex flex-col w-full p-2 gap-2 items-start justify-between">
            <p class="text-neutral-200 text-xs">Description:</p>
            <div
              class="text-neutral-200 text-xs p-2 bg-neutral-700 select-text rounded max-h-[300px] overflow-y-auto"
            >
              <div [innerHTML]="plan.plan_description | flxAiMarkdown | async"></div>
            </div>
            <p class="text-neutral-200 text-xs">
              Created At:
              <span class="text-neutral-200 font-normal">{{
                plan.created_at | flxLogDateFormat
              }}</span>
            </p>
          </div>
          <div class="flex flex-row align-end justify-between w-full h-full gap-2 mt-2">
            <div class="flex flex-row items-center justify-start gap-1">
              <p class="text-neutral-100 text-xs">Status:</p>
              <p
                [ngClass]="getPlanColorByStatus(plan.status)"
                class="text-neutral-100 py-1 px-2 font-semibold rounded"
              >
                {{ plan.status | uppercase }}
              </p>
            </div>
            <div
              [ngClass]="{ 'opacity-50 cursor-not-allowed': isAiGenerating() }"
              (click)="usePlan(plan)"
              class="py-2 px-3 h-8 font-normal items-center flex text-center bg-yellow-900 rounded-lg text-xs gap-2 hover:border-yellow-400 border-2 border-yellow-900 cursor-pointer text-yellow-500"
              tabindex="0"
              pTooltip="Use this document"
              tooltipPosition="bottom"
            >
              <i class="ph ph-sparkle text-base"></i>
              Use this plan
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
